<script>
import baseList from '@/views/components/base/baseList.vue'
import { Avatar, Button, Card, Col, Row } from 'view-design'

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: 'squad',
        key: 'id',
        url: {},
        output: false,
      },
      data: {},
      menus: [
        {
          label: '用户列表',
          name: 'user_list',
          auth: '/admin/user/lists',
        },
        {
          label: '团队列表',
          name: 'squad_list',
          auth: '/admin/squad/lists',
          //   badge: { mname: "statisticsstats", scene: "recycle_notverify" },
        },
      ],
      actions: [
        {
          label: '新增',
          icon: 'md-add',
          onClick: this.toAdd,
          auth: '/admin/squad/add',
        },
      ],
      tactions: [
        // { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '商家数据', 0), auth: '/admin/spot/lists' },
        // { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '商家数据', 1), auth: '/admin/spot/lists' },
      ],
      query: {
        model_id: this.$route?.query?.id,
        pid: 0,
      },
      currentRow: null,
      filters: [
        // { label: "加水人", name: "publish_name", value: "", type: "input" },
      ],
      tableCols: [
        {
          title: 'ID',
          width: 100,
          key: 'id',
        },
        {
          title: '团队名称',
          key: 'name',
          minWidth: 200,
          render: (h, params) => {
            const row = params.row
            let text = ''
            if (row.pid === 0) {
              text = <div style="color: #333;font-weight: 600">{row.name}</div>
            } else {
              if (row.pid_level) {
                if (row.pid_level == 1) {
                  text = <div style="margin-left: 10px">{'∟' + row.name}</div>
                }
                if (row.pid_level == 2) {
                  text = <div style="margin-left: 25px">{'∟' + row.name}</div>
                }
                if (row.pid_level == 3) {
                  text = <div style="margin-left: 40px">{'∟' + row.name}</div>
                }
              } else {
                text = <div style="margin-left: 10px">{row.name}</div>
              }
            }
            return text
          },
        },
        {
          title: '加水权限',
          align: 'center',
          key: 'is_water',
          width: 120,
          switch: true,
          disabled: true,
        },
        {
          title: '回声树权限',
          align: 'center',
          key: 'is_tree',
          width: 120,
          switch: true,
          disabled: true,
        },
        {
          title: '创建回声树',
          align: 'center',
          key: 'is_add_tree',
          width: 120,
          switch: true,
          disabled: true,
        },
        {
          title: '创建时间',
          width: 170,
          key: 'create_time',
        },
        {
          title: '状态',
          align: 'center',
          key: 'status',
          width: 120,
          switch: true,
          disabled: false,
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          key: 'handle',
          fixed: 'right',
          handle: ['edit', 'delete'],
          auth: {
            del: '/admin/squad/del',
            edit: '/admin/squad/edit',
          },
        },
      ],
    }
  },
  created() {},

  methods: {
    toAdd() {
      $utils.url.push({ name: 'squad_add', query: { action: 'add' } })
    },
  },
}
</script>
